import LoggedIn from "../layouts/loggedIn.layout";

const Test = () => {
  return <LoggedIn></LoggedIn>;
};

export default Test;
